import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Advertising} from '../../../../../../domain/advertising/model/advertising';
import {SafeSubscriberDirective} from '../../../../../../application/app-context/safe-subscriber.directive';
import {AdvertisingService} from '../../../../../../domain/advertising/service/advertising-service';
import {DeleteAdvertisingDialogComponent} from '../delete-advertising-dialog/delete-advertising-dialog.component';
import {CreateOrModifyAdvertisingDialogComponent} from '../create-or-modify/create-or-modify-advertising-dialog.component';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort, MatSortable} from '@angular/material/sort';
import {AdvertisingDialogComponent} from '../../advertising-dialog.component';
import moment from 'moment';

@Component({
  selector: 'app-list-advertising-dialog',
  templateUrl: './list-advertising-dialog.component.html',
  styleUrls: ['./list-advertising-dialog.component.scss']
})
export class ListAdvertisingDialogComponent extends SafeSubscriberDirective implements OnInit {

  displayedColumns: string[] = ['actif', 'title', 'startDate', 'endDate', 'creationDate', 'viewedQuantity', 'modify', 'duplicate', 'preview', 'delete'];

  dataSource = new MatTableDataSource([]);

  showSpinner: boolean;

  @ViewChild(MatSort) sort: MatSort;

  constructor(public dialog: MatDialog,
              public dialogRef: MatDialogRef<ListAdvertisingDialogComponent>,
              private advertisingService: AdvertisingService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    super();
    this.showSpinner = false;
  }

  ngOnInit(): void {
    this.reloadAdvertisings();
    this.dataSource.sort = this.sort;
  }


  closeDialog(): void {
    this.dialogRef.close();
  }

  isExpired(date): boolean {
    return !moment(date).isAfter(moment(new Date()));
  }

  create(): void {
    const dialogRef = this.dialog.open(CreateOrModifyAdvertisingDialogComponent, {
      id: 'CreateOrModifyAdvertisingDialogComponent',
      width: '1000px',
      height: '510px',
      data: {}
    });

    dialogRef.componentInstance.createOrModifyEvent
      .subscribe((advertisingToCreate: Advertising) => {
        this.showSpinner = true;
        this.advertisingService.createOrModify(advertisingToCreate).subscribe(() => this.reloadAdvertisings());
      });
  }

  modify(advertising: Advertising): void {
    const dialogRef = this.dialog.open(CreateOrModifyAdvertisingDialogComponent, {
      id: 'CreateOrModifyAdvertisingDialogComponent',
      width: '1000px',
      height: '510px',
      data: {
        advertising
      }
    });

    dialogRef.componentInstance.createOrModifyEvent
      .subscribe((advertisingModified: Advertising) => {
        this.showSpinner = true;
        this.advertisingService.createOrModify(advertisingModified).subscribe(() => this.reloadAdvertisings());
      });
  }

  duplicate(advertising: Advertising): void {
    advertising.id = null;
    const dialogRef = this.dialog.open(CreateOrModifyAdvertisingDialogComponent, {
      id: 'CreateOrModifyAdvertisingDialogComponent',
      width: '1000px',
      height: '510px',
      data: {
        advertising,
        duplicate: true
      }
    });

    dialogRef.componentInstance.createOrModifyEvent
      .subscribe((advertisingModified: Advertising) => {
        this.showSpinner = true;
        this.advertisingService.createOrModify(advertisingModified).subscribe(() => this.reloadAdvertisings());
      });
  }

  preview(advertising: Advertising): void {
    this.dialog.open(AdvertisingDialogComponent, {
      id: 'AdvertisingDialogComponent',
      width: '600px',
      height: '510px',
      data: {
        advertising,
        isPreview: true
      },
      panelClass: 'radius-mat-dialog'
    });
  }

  delete(advertising: Advertising): void {
    const dialogRef = this.dialog.open(DeleteAdvertisingDialogComponent, {
      id: 'DeleteAdvertisingDialogComponent',
      minWidth: '50vw',
      data: {advertising}
    });

    dialogRef.componentInstance.deleteEvent
      .subscribe((advertisingToDelete: Advertising) => {
        this.showSpinner = true;
        this.advertisingService.delete(advertisingToDelete.id).subscribe(() => this.reloadAdvertisings());
      });
  }

  private reloadAdvertisings(): void {
    this.advertisingService.findAll().subscribe(advertisings => {
      this.dataSource.data = advertisings.sort((a, b) => moment(a.startDate).isBefore(b.startDate) ? 1 : -1);
      // necessary to reload sort after change otherwise sort doesn't work
      setTimeout(() => {
        this.dataSource.sort = this.sort;
        this.dataSource.sort.sort({id: 'actif', start: 'desc'} as MatSortable);
      });
      this.showSpinner = false;
    });
  }

}
